<main class="container layout-39">
  <div id="containerLeftMenu" style="margin-right: 15px">
    <left-menu />
  </div>

  <section id="column2">
    <div class="row">
      <div class="col col-12">
        <h1>User List</h1>

        @if (isLoading) { <app-users-list-skeleton></app-users-list-skeleton> }

        @if (error) {
<div class="alert alert-danger">
          <mat-icon>error_outline</mat-icon>
          {{ error }}
        </div>
}

        @if (!isLoading) {
<div class="w-100">
          <div class="table-responsive">
            <table mat-table [dataSource]="users" matSort class="w-100 users-table">
              <!-- Dynamic Columns (same pattern as /applications) -->
              @for (col of displayedColumns; track col) {

                <ng-container [matColumnDef]="col.key">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="header-label-sort" [mat-sort-header]="col.key">
                      {{ col.label }}
                    </div>
                  </th>

                  <td mat-cell *matCellDef="let row">
                    @if (isBooleanColumn(col.key)) {

                      <mat-icon aria-label="Boolean" class="green">
                        {{ row[col.key] ? 'check_circle' : '' }}
                      </mat-icon>
                    
} @else {

                      @if (isDateColumn(col.key)) {

                        {{ formatUtcDate(row[col.key]) }}
                      
} @else {

                        {{ row[col.key] || 'N/A' }}
                      
}

                      
                    
}

                    
                  </td>
                </ng-container>
              
}

              <tr mat-header-row *matHeaderRowDef="displayedColumnsKeys"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsKeys"></tr>
            </table>
          </div>

          <mat-paginator
            [pageSize]="25"
            [pageSizeOptions]="[10, 25, 50, 100]"
            [showFirstLastButtons]="true">
          </mat-paginator>
        </div>
}
      </div>
    </div>
  </section>
</main>
